import { http } from '@/shared/api'
import { API } from '@/apps/adok/shared/api'

import type {
  SignInPayload,
  SignInResponse,
  SocialSignInQuery
} from '../model/types'

/**
 * Hand-written rather than `createEntityApi`: a session is not a record this app reads — no
 * list, no id, nothing to show.
 */

export const socialSignIn = (provider: string, query: SocialSignInQuery) =>
  http.get<unknown>(`${API.sessionSocial}/${provider}`, { params: query })

export const signIn = (payload: SignInPayload) =>
  http.post<SignInResponse>(API.session, payload)

export const signOut = () => http.delete<void>(API.session)

export interface ImpersonationTicket {
  token: string
  key: string
}

export const become = (ticket: ImpersonationTicket) =>
  http.post<unknown>(API.sessionBecome, ticket)

export const getBack = () => http.delete<unknown>(API.sessionGetBack)
